/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

import {AudioCodec, AudioCodecType} from './AudioCodec';
import assertUnreachable from '../../../../lang/assertUnreachable';

export default class AudioCodecMapping {
  public static convertAudioCodecToAudioCodecType(audioCodec: AudioCodec): AudioCodecType {
    switch (audioCodec) {
      case AudioCodec.OPUS:
        return 'OPUS';
      case AudioCodec.AAC:
        return 'AAC';
      default:
        assertUnreachable(audioCodec);
    }
  }

  public static convertAudioCodecTypeToAudioCodec(audioCodecType: AudioCodecType): AudioCodec {
    const audioCodecString = audioCodecType.toUpperCase() as keyof typeof AudioCodec;

    switch (audioCodecString) {
      case 'OPUS':
        return AudioCodec.OPUS;
      case 'AAC':
        return AudioCodec.AAC;
      default:
        assertUnreachable(audioCodecString);
    }
  }
}